import ProfileIcon from "../../assets/icons/ph_user.svg";
import SecurityIcon from "../../assets/icons/security.svg";
export const breadCrumbList = [
  {
    name: "Settings",
  },
];

export const settingsData = [
  {
      id : "1",
      cardIcon  : ProfileIcon,
      cardheading :  "My Profile",
      cardtext :  "View your profile informations",
      carButtonText : "view",
      cardbuttonValue  :"MyProfile"
  },

  {
    id: "2",
    cardIcon: SecurityIcon,
    cardheading: "Security",
    cardtext: "Manage password and advanced security options",
    carButtonText: "update",
    cardbuttonValue: "Security",
  },
];
